import { createFileRoute } from '@tanstack/react-router';

import { StockFootageReview } from '@/features/admin-terminal';

export const Route = createFileRoute('/_admin/admin/stock-footage')({
  component: StockFootagePage,
});

function StockFootagePage() {
  return (
    <div className="container max-w-6xl py-8">
      <div className="mb-6">
        <h1 className="text-3xl font-bold">Stock footage</h1>
        <p className="text-muted-foreground">
          The AI tags each clip with its treatment and body areas, and clinics
          get it straight away. Check the AI's tags here, and fix or reject
          anything that is wrong.
        </p>
      </div>
      <StockFootageReview />
    </div>
  );
}
